import type {MutationProposal} from "@/services/wingman/mutation-proposal";

/** Name the edited object from its snapshot, without interpreting generated summary prose. */
export function proposalTitle(proposal: MutationProposal): string {
   for (const snapshot of [proposal.after, proposal.before]) {
      for (const key of ["title", "name"]) {
         const value = snapshot[key];
         if (typeof value === "string" && value.trim()) return value;
      }
   }
   return proposal.summary;
}

export function proposalTypeKey(proposal: MutationProposal): string {
   return proposal.capability === "use_cases_update" ? "toolApproval.objectUseCase" : "toolApproval.objectScript";
}
